import { render, staticRenderFns } from "./SlicesBlock.vue?vue&type=template&id=2afe3a08&scoped=true&"
import script from "./SlicesBlock.vue?vue&type=script&lang=js&"
export * from "./SlicesBlock.vue?vue&type=script&lang=js&"
import style0 from "./SlicesBlock.vue?vue&type=style&index=0&id=2afe3a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe3a08",
  null
  
)

export default component.exports